import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ overline, title, subtitle, light = false, align = "left" }) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col gap-4 max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {overline && (
        <Reveal>
          <span className="overline inline-flex items-center gap-2" style={{ color: "var(--gold)" }}>
            <span className="inline-block h-px w-8" style={{ background: "var(--gold)" }} />
            {overline}
          </span>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 className={`font-serif text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.08] ${light ? "text-white" : "text-[#0A1E4E]"}`}>
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.1}>
          <p className={`text-base sm:text-lg leading-relaxed ${light ? "text-blue-100/80" : "text-slate-600"}`}>
            {subtitle}
          </p>
        </Reveal>
      )}
    </div>
  );
}
